import { render } from "./SideDetailKapal.vue?vue&type=template&id=72328b88&scoped=true"
import script from "./SideDetailKapal.vue?vue&type=script&lang=js"
export * from "./SideDetailKapal.vue?vue&type=script&lang=js"

import "./SideDetailKapal.vue?vue&type=style&index=0&id=72328b88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72328b88"]])

export default __exports__